import React, { useEffect, useRef } from "react";
import { handleDecodeURL } from "../../utils";

export default function ECPay(props) {
  const params = props.searchParams;
  const formRef = useRef(null);

  useEffect(() => {
    formRef.current.submit();
  }, []);
  return (
    <form
      ref={formRef}
      method="POST"
      action={handleDecodeURL(props.action)}
    >
      {[...params.entries()].map(([key, value]) => {
        if (key === "action" || key === "gateway" || key === "redirect") return null;
        return (
          <input
            type="hidden"
            name={key}
            key={key}
            value={handleDecodeURL(value)}
          />
        );
      })}
    </form>
  );
}
